// @flow
import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'gatsby';
import cx from 'classnames';
import styles from './Promo.module.scss';

const PromoTop = ({ redirectLink, isAbout = false }) => (
  <section
    className={cx(styles.register, styles.topBg, { [styles.about]: isAbout })}
  >
    <div className={styles.registerWrapper}>
      <div className={styles.title}>
        勝ちにこだわり、
        <br />
        大切なピースになる。
      </div>
      <Button
        variant="text"
        className={cx('btn charcoal', styles.redirectBtn)}
        component={Link}
        to={redirectLink}
      >
        採用ページはこちら
      </Button>
    </div>
  </section>
);

PromoTop.defaultProps = {
  redirectLink: '/recruit/',
};

export default PromoTop;
